// Cookie consent configuration (vanilla-cookieconsent v3)
// https://cookieconsent.orestbida.com/reference/configuration-reference.html

const cookieConfig = {
  revision: 1,

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytical: {},
    functional: {},
  },

  language: {
    default: 'de',
    translations: {
      de: {
        consentModal: {
          title: 'WIR LIEBEN 🍪',
          description:
            'Wir verwenden Cookies, die für die Nutzung der App essentiell notwendig sind.<br><br>Darüber hinaus werden Analysecookies (zur Verbesserung unseres Angebots) und funktionale Cookies (für den Versand von Push Notifications) eingesetzt. Diese werden nur nach Ihrem Einverständnis verwendet.<br><br>Weitere Informationen finden Sie in den <a href="/legal/privacy-policy" class="cc-link">Datenschutzhinweisen</a>.',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Notwendige akzeptieren',
          showPreferencesBtn: 'Einstellungen',
          revisionMessage:
            '<br><br> Dear user, terms and conditions have changed since the last time you visisted!',
        },
        preferencesModal: {
          title: 'Cookie Einstellungen',
          savePreferencesBtn: 'Auswahl speichern',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Alle ablehnen',
          closeIconLabel: 'Schließen',
          sections: [
            {
              title: 'Cookie Nutzung',
              description:
                'Weitere Informationen zu Cookies finden Sie in den <a href="/legal/privacy-policy" class="cc-link">Datenschutzhinweisen</a>.',
            },
            {
              title: 'Essentielle Cookies',
              description:
                'Diese Cookies sind unerlässlich für die Nutzung der App.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Analyse-Cookies',
              description:
                'Diese Cookies sind notwendig, um anonymisierte Informationen über Ihre Nutzung der App zu erhalten, damit wir unser Angebot noch besser auf Ihre Bedürnisse zuschneiden können.',
              linkedCategory: 'analytical',
              cookieTable: {
                caption: 'Cookie-Tabelle',
                headers: {
                  name: 'Name',
                  domain: 'Domain',
                  duration: 'Speicherdauer',
                  desc: 'Beschreibung',
                },
                body: [
                  {
                    name: '_pk_id.*',
                    domain: 'localhost',
                    duration: '12 Monate',
                    desc: 'Dieses Cookie dient der Identifizierung eines bekannten Geräts.',
                  },
                  {
                    name: '_pk_ses.*',
                    domain: 'localhost',
                    duration: '24 Stunden',
                    desc: 'Dieses Cookie dient der Identifizierung einer Nutzersitzung.',
                  },
                  {
                    name: 'MATOMO_SESSID',
                    domain: 'webstatistik.uk-koeln.de',
                    duration: '14 Tage',
                    desc: 'Dieses Cookie dient der Identifizierung einer Nutzersitzung.',
                  },
                ],
              },
            },
            {
              title: 'Funktionale Cookies',
              description:
                'Diese Cookies sind für den Versand von Push Notifications notwendig.',
              linkedCategory: 'functional',
              cookieTable: {
                caption: 'Cookie-Tabelle',
                headers: {
                  name: 'Name',
                  domain: 'Domain',
                  duration: 'Speicherdauer',
                  desc: 'Beschreibung',
                },
                body: [
                  {
                    name: 'token',
                    domain: '.google.com',
                    duration: '2 Jahre',
                    desc: 'Dieses Cookie ist für den Versand von Push Notifications notwendig und dient der Identifizierung eines bekannten Geräts.',
                  },
                ],
              },
            },
          ],
        },
      },
    },
  },
};

export default cookieConfig;
